/**
 * `storefrontPublic.*` — public-facing storefront procedures (ADR-0052).
 *
 * Anonymous, no auth required. Slug resolution is the only scoping mechanism.
 * Served only when `FLINT_API_MODE=public`.
 *
 * @see docs/spec/19-store-foundation.md
 */
import { z } from "zod";

/** Lowercase kebab slug — canonical URLs only, no fuzzy matching. */
const slug = z
  .string()
  .min(1)
  .max(64)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "lowercase kebab slug");

export const getStoreInput = z.object({ slug });

export const getStoreOutput = z.object({
  id: z.string().uuid(),
  name: z.string(),
  slug: z.string(),
  description: z.string().nullable(),
});

export const listActiveSlugsOutput = z.object({
  slugs: z.array(
    z.object({
      slug: z.string(),
      updatedAt: z.string().datetime().nullable(),
    }),
  ),
});
